import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import { roleToken } from "./vault_roles.mjs";

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: true,
    state: {
        isAuthenticated: false,

        user: {
            data: {},
            role: {},
            role_id: "",
            roles: []
        },
        vaults: {
            current: {},
            all: [],
            roles: {}
        },
        categorized_tags: [],

        plans: {},

        recently_filed: []
    },

    mutations: {
        // user
        isAuthenticated(state, payload) {
            state.isAuthenticated = payload.isAuthenticated;
        },
        setUser(state, data) {
            state.user.data = data;
        },
        setUserRole(state, data) {
            state.user.role_id = data.id;
            // my-role is fetched for the route's vault, so strip whatever vault
            // id prefix it carries. Using the current vault here broke direct
            // page loads, where the current vault is not set yet.
            state.user.role = roleToken(data.name);
        },

        // vaults
        setVaults(state, data) {
            state.vaults.all = data;
        },
        setCurrentVault(state, data) {
            let current = _.find(state.vaults.all, function (vault) {
                return vault.id == data;
            });
            if (current != undefined) {
                state.vaults.current = current;
            }
        },
        setVaultRoles(state, data) {
            state.vaults.roles = data;
        },

        // tagging
        setCategorizedTags(state, data) {
            if (require('lodash').findIndex(state.categorized_tags, ['for_vault', data.for_vault]) !== -1) {
                state.categorized_tags.splice(require('lodash').findIndex(state.categorized_tags, ['for_vault', data.for_vault]), 1);
            }

            let cat_tags = {
                for_vault: require('lodash').toInteger(data.for_vault),
                tags: data.tags
            };

            state.categorized_tags.push(cat_tags);
        },
        setFileAsRecent(state, data) {
            state.recently_filed.push(data);
        },
        resetRecentFiles(state, data) {
            state.recently_filed = [];
        },

        // Billing
        setPlans(state, data) {
            state.plans = data;
        },

        setRoles(state, data) {
            state.user.roles = data;
        }
    },

    getters: {
        // user
        isAuthenticated: state => {
            return state.isAuthenticated;
        },
        getUser: state => {
            return state.user.data;
        },
        getUserRole: state => {
            return state.user.role;
        },
        getUserRoleId: state => {
            return state.user.role_id;
        },
        getUserFullName: state => {
            if(!state.user.data.last_name) {
                return state.user.data.first_name;
            }
            return state.user.data.first_name + " " + state.user.data.last_name;
        },

        // vaults
        getVaults: state => {
            return state.vaults.all;
        },
        getCurrentVault: state => {
            return state.vaults.current;
        },
        getVaultRoles: state => {
            return state.vaults.roles;
        },

        // tagging
        getCategorizedTags: state => {
            let data = _.findLast(state.categorized_tags, cat_tag => {
                return cat_tag.for_vault == router.app.$route.params.vault_id;
            });

            if (!_.isEmpty(data)) {
                return data.tags;
            }

            return null;
        },
        getRecentFiles: state => {
            return state.recently_filed;
        },

        // billing
        getPlans: state => {
            return state.plans;
        },

        getRoles: state => {
            return state.user.roles;
        },

        getVaultsWithRole: state => {
            return state.vaults.all.map(vault => {
                vault.role = state.user.roles.find(role => {
                    return role.name.split('-')[0] == vault.id;
                });
                return vault;
            })
        },
    },

    actions: {
        login(context, payload) {
            router.app.$auth
                .login(null, {
                    method: "GET"
                })
                .then(({
                    data
                }) => {
                    // if data is blank means the user is not logged in, must redirect to log in
                    if (data) {
                        context.commit("isAuthenticated", {
                            isAuthenticated: router.app.$auth.isAuthenticated()
                        });

                        context.commit("setUser", data);
                    } else {
                        window.location.href = "/auth-login";
                    }
                });
        }
    }
});

export default store;
